import { ref } from '@nuxtjs/composition-api';
import { useApi } from '~/composables/useApi';
import { GetCustomRelatedProducts } from './useCustomRelatedProducts.gql';

export type RelatedProduct = {
  uid: string;
  __typename?: string;
  sku: string;
  name: string;
  stock_status?: string;
  only_x_left_in_stock?: number;
  hideprice?: number;
  category_image?: string;
  thumbnail?: {
    url: string;
    position?: number;
    disabled?: boolean;
    label?: string;
    __typename?: string;
  };
  url_key?: string;
  url_rewrites?: Array<{
    url: string;
    __typename?: string;
  }>;
  price_range?: {
    maximum_price: {
      final_price: {
        currency: string;
        value: number;
      };
      regular_price: {
        currency: string;
        value: number;
      };
    };
    minimum_price: {
        final_price: {
        currency: string;
        value: number;
      };
      regular_price: {
        currency: string;
        value: number;
      };
    };
  };
};
  
  
type ProductsResponse = {
  products: {
    items: Array<{
      sku: string;
      name: string;
      related_products: RelatedProduct[];
    }>;
  };
};
  

export const useCustomRelatedProducts = () => {
  const { query } = useApi();
  const relatedProducts = ref<RelatedProduct[]>([]);
  const loading = ref(false);
  const error = ref<Error | null>(null);

  const load = async (searchQuery: { filter: { sku: { eq: string } } }) => {
    loading.value = true;
    error.value = null;

    try {
      const { data } = await query<ProductsResponse>(GetCustomRelatedProducts, searchQuery);

      relatedProducts.value = data?.products?.items?.[0]?.related_products ?? [];
    } catch (err) {
      error.value = err as Error;
      console.error('Error loading related products:', err);
    } finally {
      loading.value = false;
    }
  };

  return {
    relatedProducts,
    load,
    loading,
    error,
  };
};
